import ServiceBase from "base/baseService"

export default class OperacaoService extends ServiceBase {

    title = "Operação"
    pluralTitle = "Operações"
    url = '/cadastro/outros/operacao'
    frontUrl = '/cadastro/outros/operacao'
    frontUrlList = '/cadastro/outros/operacaolist'
    primaryKey = 'codigo_ope'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {
        data.codigo_ope = data?.codigo_ope || ''
        data.descricao_ope = data?.descricao_ope || ''
        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }

}
